import { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";

function Login() {
  const [nom, setNom] = useState("");
  const [motDePasse, setMotDePasse] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    setLoading(true);
    setError("");

    try {
      const res = await api.post("/auth/login", {
        nom: nom.trim(),
        mot_de_passe: motDePasse
      });

      const data = res.data;

      console.log("LOGIN SUCCESS:", data);

      // ======================================================
      // STOCKAGE AUTHENTIFICATION
      // ======================================================

      localStorage.setItem(
        "accessToken",
        data.accessToken
      );

      localStorage.setItem(
        "refreshToken",
        data.refreshToken
      );

      localStorage.setItem(
        "role",
        data.role
      );

      // ======================================================
      // REDIRECTION SELON LE RÔLE
      // ======================================================

      switch (data.role) {

        case "admin":
          navigate(
            "/admindashboard",
            { replace: true }
          );
          break;

        case "prestataire":
          navigate(
            "/blanchisserie",
            { replace: true }
          );
          break;

        case "receptionniste":
          navigate(
            "/dashboard",
            { replace: true }
          );
          break;

        case "comptable":
          navigate(
            "/dashboard",
            { replace: true }
          );
          break;

        default:
          console.warn(
            "Rôle utilisateur inconnu :",
            data.role
          );

          setError(
            "Rôle utilisateur non reconnu."
          );

          // On évite de laisser un utilisateur
          // avec un rôle inconnu entrer dans l'application.
          localStorage.removeItem(
            "accessToken"
          );

          localStorage.removeItem(
            "refreshToken"
          );

          localStorage.removeItem(
            "role"
          );

          navigate(
            "/",
            { replace: true }
          );
      }

    } catch (err) {
      console.error(
        "Erreur login :",
        err
      );

      if (
        err.response &&
        err.response.data &&
        err.response.data.error
      ) {
        setError(
          err.response.data.error
        );
      } else {
        setError(
          "Erreur de connexion"
        );
      }

    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="h-screen flex items-center justify-center bg-gray-300">

      <form
        onSubmit={handleLogin}
        className="bg-white p-6 rounded-2xl shadow w-80 space-y-3"
      >

        <h2 className="text-xl font-bold text-center">
          Connexion
        </h2>

        {error && (
          <p className="text-red-500 text-sm">
            {error}
          </p>
        )}

        <input
          placeholder="Nom"
          value={nom}
          onChange={(e) =>
            setNom(e.target.value)
          }
          className="w-full border p-2 rounded-lg"
          autoComplete="username"
        />

        <input
          type="password"
          placeholder="Mot de passe"
          value={motDePasse}
          onChange={(e) =>
            setMotDePasse(
              e.target.value
            )
          }
          className="w-full border p-2 rounded-lg"
          autoComplete="current-password"
        />

        <button
          type="submit"
          disabled={loading}
          className={`w-full py-2 rounded-lg text-white ${
            loading
              ? "bg-gray-400"
              : "bg-blue-600"
          }`}
        >
          {loading
            ? "Connexion..."
            : "Se connecter"}
        </button>

      </form>

    </div>
  );
}

export default Login;